export default class SessionStorageHelper {
  static get = key => JSON.parse(window.sessionStorage.getItem(key));

  static set = (key, value) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  };
}
